import { render, staticRenderFns } from "./menu_bienvenue.vue?vue&type=template&id=694285e2"
import script from "./menu_bienvenue.js?vue&type=script&lang=js&external"
export * from "./menu_bienvenue.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports